import { productSalzburgTemplateBlueprints } from "@made-people/blueprint-product/blueprint";

productSalzburgTemplateBlueprints.main.override({
  slots: {
    base: "flex flex-col lg:grid lg:grid-cols-12 gap-4 lg:gap-10 w-full lg:bg-white lg:pl-10  lg:pr-4 lg:py-4 lg:rounded-lg",
    detailsWrapper:
      "flex flex-col col-span-6 justify-center order-2 lg:order-1 px-6 lg:px-0 ",
    returnPolicyWrapper:
      "col-span-12 text-heading-2xs lg:text-body-sm mt-6 lg:mt-4",
  },
  variants: {
    layout: {
      row: {
        base: "",
        detailsWrapper: "",
      },
      "row-reverse": {
        base: "lg:pr-10 lg:pl-4",
        detailsWrapper: "lg:order-3",
      },
    },
  },
  defaultVariants: {
    layout: "row",
  },
});

productSalzburgTemplateBlueprints.gallery.override({
  slots: {
    base: "w-full lg:col-span-6 overflow-hidden order-1 lg:order-2",
    galleryWrapper: "relative flex overflow-hidden lg:rounded-lg",
    imageWrapper: "bg-[#F6F6F6] aspect-product-image h-full",
    image: "object-cover w-full h-full aspect-product-image",
    peekingImage: "opacity-50 absolute inset-0 bg-background-page",
    thumbnailWrapper: "!hidden",
    dotsIndicatorWrapper: "hidden",
    dotsIndicator: "",
    arrowsWrapper: "flex justify-between absolute top-1/2 left-2 right-2",
    leftArrow:
      "p-4 fill-black rounded-full bg-white border border-border-light",
    rightArrow:
      "p-4 fill-black rounded-full bg-white border border-border-light",
  },
});

productSalzburgTemplateBlueprints.details.override({
  slots: {
    priceWrapper: "flex flex-col col-start-3 col-end-4 flex-1 justify-center",
    oldPrice: "",
    price:
      "text-body-lg lg:text-heading-md data-[is-discounted=true]:text-sale-price data-[is-discounted=true]:line-through",
    name: "col-start-1 col-end-3 text-heading-md lg:text-heading-display-md font-secondary",
    description:
      "text-body-sm lg:text-body-md lg:row-start-3 col-start-1 col-span-6 my-3 lg:my-6 text-text-less-emphasis-1",
  },
});
